document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    const shadowHost = document.querySelector('shop-follow-button');

    if (shadowHost && shadowHost.shadowRoot) {
      console.log("test");

      const style = document.createElement('style');
      style.textContent = `
        .bg-transparent {
            background: white;
        }

        .bg-purple-primary {
            background-color: white;
        }

        .transition-colors {
            color: #5433EB !important;
        }

        .text-white {
            color: #5433EB !important;
            font-size: 18px !important;
            align-items: flex-end !important;
            gap: 2px;
            display: flex !important;
        }

        .bg-transparent {
            width: 100%;
        }

        .relative.z-0 {
            width: 100%;
        }

        button.group.relative.inline-flex.h-9.items-center.rounded-max.bg-transparent {
            background: white;
            justify-content: center;
            border-radius: 4px;
            height: 50px;
        }

        svg.relative.inline-block.h-4.w-auto {
            height: 24px !important;
            margin-left: 4px !important;
        }
      `;

      shadowHost.shadowRoot.appendChild(style);
    }
  }, 500);
});
